export class PharmacyStoreSyncSearchRequestModel {
    public FileDate?: String;
}

export class PharmacyStoreSyncSearchResponseModel {
    public ActionType: String;
    public NCPDPID: String;
    public PharmacyName: String;
    public OldPharmacyName: String;
    public ProcessFileDate: String;
    public ProcessFileName: String;
    public ProcessDate: String;
}

export class PharmacyStoreSyncSearchGridData{
    public TotalNumberOfRecords :number;
    public pharmacyStoreSyncSearchData :PharmacyStoreSyncSearchResponseModel[];
}
  
export class PharmacyStoreSyncSearchGridDataMapper{
mapToModel(json: any): PharmacyStoreSyncSearchGridData {
    let pharmacyStoreSyncSearchGridData: PharmacyStoreSyncSearchGridData = null;

    if (json) {
    pharmacyStoreSyncSearchGridData = new PharmacyStoreSyncSearchGridData();
    pharmacyStoreSyncSearchGridData.pharmacyStoreSyncSearchData = json.ResponseData;
    }
    return pharmacyStoreSyncSearchGridData;
}
}
